import { setThreatDomains } from "./threatEngine";

// Feed gratuito di domini malevoli aggiornato periodicamente sul server (URLhaus).
// Best-effort: se offline, restano attive le euristiche locali del motore.
const THREAT_LIST_URL = "https://lattice-network.it/downloads/threats.json";

export async function loadThreatList() {
  try {
    const r = await fetch(`${THREAT_LIST_URL}?t=${Date.now()}`);
    if (!r.ok) return 0;
    const j = await r.json();
    if (Array.isArray(j?.domains)) { setThreatDomains(j.domains); return j.domains.length; }
  } catch { /* nessuna rete: euristiche locali sempre attive */ }
  return 0;
}
